import React, { Component } from "react";
import { Button } from "carbon-components-react";
// Import './button.scss';

class Buttons extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<Button
				id={this.props.id}
				className={this.props.className}
				onClick={this.props.onClick}
				onFocus={this.props.onFocus}
				kind={this.props.kind || "primary"}
				disabled={this.props.disabled}
				data-tracking-id-alt={this.props.label}
			>
				{this.props.label}
			</Button>
		);
	}
}

export default Buttons;
